/* Consulta CT-e: CT-e capturados da Distribuição de DF-e do CT-e (backend /cte-captura) */
import { apiFetch, API_URL, obterToken } from './apiClient';

const B = '/cte-captura';
const qs = (p) => {
  const u = new URLSearchParams();
  Object.entries(p || {}).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== '') u.set(k, v); });
  const s = u.toString();
  return s ? `?${s}` : '';
};

export const listarClientesCte = () => apiFetch(`${B}/clientes`);
export const listarCtes = (filtro) => apiFetch(`${B}/documentos${qs(filtro)}`);
export const listarExecucoesCte = (clienteId) => apiFetch(`${B}/execucoes${qs({ cliente_id: clienteId })}`);
export const sincronizarClienteCte = (id) => apiFetch(`${B}/clientes/${id}/sincronizar`, { method: 'POST' });
export const ativarBuscaCte = (id, ativo) => apiFetch(`${B}/clientes/${id}/ativacao`, { method: 'PUT', body: JSON.stringify({ ativo }) });
export const executarCapturaCteTodos = () => apiFetch(`${B}/executar`, { method: 'POST' });

export async function baixarCte(caminho, nomePadrao) {
  const token = obterToken();
  const r = await fetch(`${API_URL}${B}${caminho}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
  if (!r.ok) {
    let msg = 'Erro ao baixar o arquivo';
    try { msg = (await r.json()).error || msg; } catch { /* sem JSON */ }
    throw new Error(msg);
  }
  const nome = (/filename="([^"]+)"/.exec(r.headers.get('content-disposition') || '') || [])[1] || nomePadrao;
  const url = URL.createObjectURL(await r.blob());
  const a = document.createElement('a');
  a.href = url; a.download = nome;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
export const urlZipCte = (filtro) => `/zip${qs(filtro)}`;
